import React, { Component } from 'react';

class Alert extends Component {
  constructor(props) {
    super(props);
    this.onClose = this.props.onClose.bind(this);
  }
  render() {
    return (
      <div className="comp-alert">
        <span className="iconleft">
          <img src="/assets/images/infoico.svg" alt="info icon" />
        </span>
        <p>{this.props.children}</p>
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/Alert.jsx